import React, { useState } from 'react';

import { DataView } from 'primereact/dataview';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';


import {TablaResumen } from './TablaResumen';

import servicioObjetos from '../../servicio/ServicioObjetos';

export const VistaDatos = (props) => {

    const { datos } = props;
    const layout = 'list';
    const [mostrarModal, setMostrarModal] = useState(false);
    const [tituloDialogo, setTituloDialogo] = useState("");
    const [datosTabla, setDatosTabla] = useState([]);

    const header = () => {

    }

    const itemTemplate = (renglon, layout) => {
        if (!renglon) {
            return <div></div>;
        }
        return (
            <div className="p-grid">
                <div className="p-col-12">
                    <div className="card">
                        <div>
                            <div className="p-grid">
                                <div className="p-col-12">Registro Patronal: <b>{renglon.registroPatronal}</b></div>
                                <div className="p-col-12">Nombre del archivo : <b>{renglon.nombreArchivo}</b></div>
                                <div className="p-col-12">Errores : <b>{servicioObjetos.esObjetoVacio(renglon.errores) ? "No" : "Si"}</b></div>
                            </div>
                        </div>
                        <Button icon="pi pi-search" tooltip="Ver Resultados" onClick={(e) => { prepararTablaDialogo(renglon) }}></Button>
                        <Button icon="pi-md-delete" className="p-button-danger" tooltip="Eliminar" onClick={(e) => { eliminarElemento(renglon) }}></Button>
                    </div>
                </div>
            </div>
        );
    };

    const prepararTablaDialogo = (renglon) => {
        setMostrarModal(true);
        setTituloDialogo("Movimientos en archivo: " + renglon.nombreArchivo);
        setDatosTabla(renglon.renglones);        
    }

    const eliminarElemento = (renglon) => {
        servicioObjetos.eliminarObjetoMapa(datos,renglon);
    }
    return (
        <div>
            <DataView value={datos} layout={layout} header={header}
                itemTemplate={itemTemplate} paginatorPosition={'both'} paginator={true} rows={20}/>

            <Dialog header={tituloDialogo} visible={mostrarModal} modal={true} onHide={() => setMostrarModal(false)}
              appendTo={document.body} style={{ width: '90%', height: '90%' }} >
                <TablaResumen datosTabla={datosTabla} titulo={tituloDialogo}/>
            </Dialog>
        </div>
    );
}